export const SplitNames: { [key: string]: string[] } = {
	bulbasaur: ["Bulba", "saur"],
	ivysaur: ["Ivy", "saur"],
	venusaur: ["Venu", "saur"],
	charmander: ["Char", "mander"],
	charmeleon: ["Char", "meleon"],
	charizard: ["Char", "izard"],
	squirtle: ["Squirt", "tle"],
	wartortle: ["War", "tortle"],
	blastoise: ["Blast", "toise"],
	caterpie: ["Cater", "pie"],
	metapod: ["Meta", "pod"],
	butterfree: ["Butter", "free"],
	weedle: ["Wee", "dle"],
	kakuna: ["Kak", "una"],
	beedrill: ["Bee", "drill"],
	pidgey: ["Pid", "gey"],
	pidgeotto: ["Pidge", "otto"],
	pidgeot: ["Pid", "geot"],
	rattata: ["Rat", "tata"],
	raticate: ["Rat", "icate"],
	spearow: ["Spear", "row"],
	fearow: ["Fear", "row"],
	ekans: ["Ek", "ans"],
	arbok: ["Ar", "bok"],
	pikachu: ["Pika", "chu"],
	raichu: ["Rai", "chu"],
	sandshrew: ["Sand", "shrew"],
	sandslash: ["Sand", "slash"],
	nidoranf: ["Nido", "ran"],
	nidorina: ["Nido", "rina"],
	nidoqueen: ["Nido", "queen"],
	nidoranm: ["Nido", "ran"],
	nidorino: ["Nido", "rino"],
	nidoking: ["Nido", "king"],
	clefairy: ["Clef", "fairy"],
	clefable: ["Clef", "fable"],
	vulpix: ["Vul", "pix"],
	ninetales: ["Nine", "tales"],
	jigglypuff: ["Jiggly", "puff"],
	wigglytuff: ["Wiggly", "tuff"],
	zubat: ["Zu", "bat"],
	golbat: ["Gol", "bat"],
	oddish: ["Odd", "ish"],
	gloom: ["Gloo", "oom"],
	vileplume: ["Vile", "plume"],
	paras: ["Pa", "ras"],
	parasect: ["Para", "sect"],
	venonat: ["Veno", "nat"],
	venomoth: ["Veno", "moth"],
	diglett: ["Dig", "lett"],
	dugtrio: ["Dug", "trio"],
	meowth: ["Meow", "th"],
	persian: ["Per", "sian"],
	psyduck: ["Psy", "duck"],
	golduck: ["Gol", "duck"],
	mankey: ["Man", "key"],
	primeape: ["Prime", "ape"],
	growlithe: ["Growl", "lithe"],
	arcanine: ["Arca", "nine"],
	poliwag: ["Poli", "wag"],
	poliwhirl: ["Poli", "whirl"],
	poliwrath: ["Poli", "wrath"],
	abra: ["Ab", "ra"],
	kadabra: ["Kada", "bra"],
	alakazam: ["Ala", "kazam"],
	machop: ["Ma", "chop"],
	machoke: ["Ma", "choke"],
	machamp: ["Ma", "champ"],
	bellsprout: ["Bell", "sprout"],
	weepinbell: ["Weepin", "bell"],
	victreebel: ["Victree", "bell"],
	tentacool: ["Tenta", "cool"],
	tentacruel: ["Tenta", "cruel"],
	geodude: ["Geo", "dude"],
	graveler: ["Grave", "ler"],
	golem: ["Go", "lem"],
	ponyta: ["Pony", "ta"],
	rapidash: ["Rapi", "dash"],
	slowpoke: ["Slow", "poke"],
	slowbro: ["Slow", "bro"],
	magnemite: ["Magne", "mite"],
	magneton: ["Magne", "ton"],
	farfetchd: ["Far", "fetchd"],
	doduo: ["Do", "duo"],
	dodrio: ["Do", "drio"],
	seel: ["See", "eel"],
	dewgong: ["Dew", "gong"],
	grimer: ["Gri", "mer"],
	muk: ["Mu", "uk"],
	shellder: ["Shell", "der"],
	cloyster: ["Cloy", "ster"],
	gastly: ["Gas", "tly"],
	haunter: ["Haun", "ter"],
	gengar: ["Gen", "gar"],
	onix: ["On", "nix"],
	drowzee: ["Drow", "zee"],
	hypno: ["Hyp", "no"],
	krabby: ["Krab", "by"],
	kingler: ["King", "ler"],
	voltorb: ["Volt", "orb"],
	electrode: ["Electr", "ode"],
	exeggcute: ["Exegg", "cute"],
	exeggutor: ["Exeggu", "tor"],
	cubone: ["Cu", "bone"],
	marowak: ["Maro", "wak"],
	hitmonlee: ["Hitmon", "lee"],
	hitmonchan: ["Hitmon", "chan"],
	lickitung: ["Licki", "tung"],
	koffing: ["Koff", "fing"],
	weezing: ["Wee", "zing"],
	rhyhorn: ["Rhy", "horn"],
	rhydon: ["Rhy", "don"],
	chansey: ["Chan", "sey"],
	tangela: ["Tan", "gela"],
	kangaskhan: ["Kangas", "khan"],
	horsea: ["Hor", "sea"],
	seadra: ["Sea", "dra"],
	goldeen: ["Gol", "deen"],
	seaking: ["Sea", "king"],
	staryu: ["Star", "yu"],
	starmie: ["Star", "mie"],
	mrmime: ["Mr. ", "mime"],
	scyther: ["Scy", "ther"],
	jynx: ["Jyn", "nx"],
	electabuzz: ["Electa", "buzz"],
	magmar: ["Mag", "mar"],
	pinsir: ["Pin", "sir"],
	tauros: ["Tau", "ros"],
	magikarp: ["Magi", "karp"],
	gyarados: ["Gyara", "dos"],
	lapras: ["Lap", "ras"],
	ditto: ["Dit", "to"],
	eevee: ["Ee", "vee"],
	vaporeon: ["Vapor", "eon"],
	jolteon: ["Jolt", "eon"],
	flareon: ["Fla", "reon"],
	porygon: ["Pory", "gon"],
	omanyte: ["Oma", "nyte"],
	omastar: ["Oma", "star"],
	kabuto: ["Kabu", "to"],
	kabutops: ["Kabu", "tops"],
	aerodactyl: ["Aero", "dactyl"],
	snorlax: ["Snor", "lax"],
	articuno: ["Arti", "cuno"],
	zapdos: ["Zap", "dos"],
	moltres: ["Mol", "tres"],
	dratini: ["Dra", "tini"],
	dragonair: ["Drago", "nair"],
	dragonite: ["Drago", "nite"],
	mewtwo: ["Mew", "two"],
	mew: ["Mew", "ew"],
	chikorita: ["Chiko", "rita"],
	bayleef: ["Bay", "leef"],
	meganium: ["Mega", "nium"],
	cyndaquil: ["Cynda", "quil"],
	quilava: ["Qui", "lava"],
	typhlosion: ["Typh", "losion"],
	totodile: ["Toto", "dile"],
	croconaw: ["Croco", "naw"],
	feraligatr: ["Fera", "ligatr"],
	sentret: ["Sen", "tret"],
	furret: ["Fur", "ret"],
	hoothoot: ["Hoot", "hoot"],
	noctowl: ["Noct", "owl"],
	ledyba: ["Ledy", "ba"],
	ledian: ["Led", "ian"],
	spinarak: ["Spina", "rak"],
	ariados: ["Aria", "dos"],
	crobat: ["Cro", "bat"],
	chinchou: ["Chin", "chou"],
	lanturn: ["Lan", "turn"],
	pichu: ["Pi", "chu"],
	cleffa: ["Clef", "fa"],
	igglybuff: ["Iggly", "buff"],
	togepi: ["Toge", "pi"],
	togetic: ["Toge", "tic"],
	natu: ["Na", "tu"],
	xatu: ["Xa", "tu"],
	mareep: ["Ma", "reep"],
	flaaffy: ["Flaa", "ffy"],
	ampharos: ["Ampha", "ros"],
	bellossom: ["Bell", "ossom"],
	marill: ["Ma", "rill"],
	azumarill: ["Azuma", "rill"],
	sudowoodo: ["Sudo", "woodo"],
	politoed: ["Poli", "toed"],
	hoppip: ["Hop", "pip"],
	skiploom: ["Skip", "loom"],
	jumpluff: ["Jump", "luff"],
	aipom: ["Ai", "pom"],
	sunkern: ["Sun", "kern"],
	sunflora: ["Sun", "flora"],
	yanma: ["Yan", "ma"],
	wooper: ["Woo", "per"],
	quagsire: ["Quag", "sire"],
	espeon: ["Es", "peon"],
	umbreon: ["Umb", "reon"],
	murkrow: ["Mur", "krow"],
	slowking: ["Slow", "king"],
	misdreavus: ["Miss ", "dreavus"],
	unown: ["Un", "own"],
	wobbuffet: ["Wob", "buffet"],
	girafarig: ["Gira", "farig"],
	pineco: ["Pine", "co"],
	forretress: ["Forre", "tress"],
	dunsparce: ["Dun", "sparce"],
	gligar: ["Gli", "gar"],
	steelix: ["Stee", "lix"],
	snubbull: ["Snub", "bull"],
	granbull: ["Gran", "bull"],
	qwilfish: ["Qwil", "fish"],
	scizor: ["Sci", "zor"],
	shuckle: ["Shu", "ckle"],
	heracross: ["Hera", "cross"],
	sneasel: ["Snea", "sel"],
	teddiursa: ["Teddi", "ursa"],
	ursaring: ["Ursa", "ring"],
	slugma: ["Slug", "gma"],
	magcargo: ["Mag", "cargo"],
	swinub: ["Swi", "nub"],
	piloswine: ["Pilo", "swine"],
	corsola: ["Cor", "sola"],
	remoraid: ["Remo", "raid"],
	octillery: ["Octi", "llery"],
	delibird: ["Deli", "bird"],
	mantine: ["Man", "tine"],
	skarmory: ["Skar", "mory"],
	houndour: ["Houn", "dour"],
	houndoom: ["Houn", "doom"],
	kingdra: ["King", "dra"],
	phanpy: ["Phan", "py"],
	donphan: ["Don", "phan"],
	porygon2: ["Pory", "gon2"],
	stantler: ["Stan", "tler"],
	smeargle: ["Smear", "gle"],
	tyrogue: ["Ty", "rogue"],
	hitmontop: ["Hitmon", "top"],
	smoochum: ["Smoo", "chum"],
	elekid: ["Ele", "kid"],
	magby: ["Mag", "by"],
	miltank: ["Mil", "tank"],
	blissey: ["Blis", "sey"],
	raikou: ["Rai", "kou"],
	entei: ["En", "tei"],
	suicune: ["Sui", "cune"],
	larvitar: ["Larvi", "tar"],
	pupitar: ["Pupi", "tar"],
	tyranitar: ["Tyran", "itar"],
	lugia: ["Lu", "gia"],
	hooh: ["Ho-", "oh"],
	celebi: ["Cele", "bi"],
	treecko: ["Tree", "cko"],
	grovyle: ["Gro", "vyle"],
	sceptile: ["Scep", "tile"],
	torchic: ["Torch", "chic"],
	combusken: ["Com", "busken"],
	blaziken: ["Blaz", "ziken"],
	mudkip: ["Mud", "kip"],
	marshtomp: ["Marsh", "tomp"],
	swampert: ["Swamp", "pert"],
	poochyena: ["Pooch", "yena"],
	mightyena: ["Might", "tyena"],
	zigzagoon: ["Zig", "zagoon"],
	linoone: ["Lin", "noone"],
	wurmple: ["Wurm", "ple"],
	silcoon: ["Sil", "coon"],
	beautifly: ["Beauti", "fly"],
	cascoon: ["Cas", "scoon"],
	dustox: ["Dust", "tox"],
	lotad: ["Lo", "tad"],
	lombre: ["Lom", "bre"],
	ludicolo: ["Ludi", "colo"],
	seedot: ["Seed", "dot"],
	nuzleaf: ["Nuz", "leaf"],
	shiftry: ["Shift", "try"],
	taillow: ["Tail", "low"],
	swellow: ["Swell", "wellow"],
	wingull: ["Wing", "gull"],
	pelipper: ["Peli", "liper"],
	ralts: ["Ral", "ts"],
	kirlia: ["Kir", "lia"],
	gardevoir: ["Garde", "voir"],
	surskit: ["Sur", "skit"],
	masquerain: ["Masque", "rain"],
	shroomish: ["Shroom", "mish"],
	breloom: ["Bre", "reloom"],
	slakoth: ["Sla", "oth"],
	vigoroth: ["Vigor", "roth"],
	slaking: ["Slak", "aking"],
	nincada: ["Nin", "cada"],
	ninjask: ["Nin", "jask"],
	shedinja: ["Shed", "inja"],
	whismur: ["Whism", "mur"],
	loudred: ["Loud", "dred"],
	exploud: ["Exp", "loud"],
	makuhita: ["Maku", "hita"],
	hariyama: ["Hari", "yama"],
	azurill: ["Azu", "rill"],
	nosepass: ["Nose", "ass"],
	skitty: ["Skit", "itty"],
	delcatty: ["Del", "catty"],
	sableye: ["Sabl", "eye"],
	mawile: ["Maw", "wile"],
	aron: ["Ar", "on"],
	lairon: ["Lair", "ron"],
	aggron: ["Agg", "gron"],
	meditite: ["Med", "tite"],
	medicham: ["Medi", "cham"],
	electrike: ["Elect", "trike"],
	manectric: ["Mane", "tric"],
	plusle: ["Plus", "le"],
	minun: ["Min", "un"],
	volbeat: ["Vol", "beat"],
	illumise: ["Illu", "mise"],
	roselia: ["Rose", "elia"],
	gulpin: ["Gulp", "in"],
	swalot: ["Swal", "ot"],
	carvanha: ["Car", "vanha"],
	sharpedo: ["Sharp", "edo"],
	wailmer: ["Wail", "mer"],
	wailord: ["Wail", "lord"],
	numel: ["Nu", "mel"],
	camerupt: ["Came", "rupt"],
	torkoal: ["Tor", "koal"],
	spoink: ["Spo", "ink"],
	grumpig: ["Grum", "pig"],
	spinda: ["Spin", "da"],
	trapinch: ["Trap", "inch"],
	vibrava: ["Vibra", "va"],
	flygon: ["Fly", "gon"],
	cacnea: ["Cac", "nea"],
	cacturne: ["Cact", "turne"],
	swablu: ["Swab", "lu"],
	altaria: ["Alta", "ria"],
	zangoose: ["Zan", "goose"],
	seviper: ["Se", "viper"],
	lunatone: ["Luna", "atone"],
	solrock: ["Sol", "lrock"],
	barboach: ["Bar", "boach"],
	whiscash: ["Whis", "cash"],
	corphish: ["Corp", "phish"],
	crawdaunt: ["Craw", "daunt"],
	baltoy: ["Bal", "toy"],
	claydol: ["Clay", "dol"],
	lileep: ["Lil", "leep"],
	cradily: ["Crad", "dily"],
	anorith: ["Ano", "rith"],
	armaldo: ["Arm", "aldo"],
	feebas: ["Fee", "bas"],
	milotic: ["Milo", "tic"],
	castform: ["Cast", "form"],
	kecleon: ["Kec", "eon"],
	shuppet: ["Shup", "pet"],
	banette: ["Ban", "nette"],
	duskull: ["Dus", "skull"],
	dusclops: ["Dusc", "clops"],
	tropius: ["Tro", "pius"],
	chimecho: ["Chime", "echo"],
	absol: ["Ab", "sol"],
	wynaut: ["Wy", "naut"],
	snorunt: ["Sno", "runt"],
	glalie: ["Gla", "lie"],
	spheal: ["Sphe", "eal"],
	sealeo: ["Sea", "leo"],
	walrein: ["Wal", "rein"],
	clamperl: ["Clamp", "perl"],
	huntail: ["Hun", "tail"],
	gorebyss: ["Gore", "byss"],
	relicanth: ["Reli", "canth"],
	luvdisc: ["Luv", "disc"],
	bagon: ["Ba", "agon"],
	shelgon: ["Shel", "elgon"],
	salamence: ["Sala", "mence"],
	beldum: ["Bel", "dum"],
	metang: ["Met", "tang"],
	metagross: ["Meta", "gross"],
	regirock: ["Regi", "rock"],
	regice: ["Regi", "ice"],
	registeel: ["Regi", "steel"],
	latias: ["Latia", "tias"],
	latios: ["Latio", "tios"],
	kyogre: ["Kyo", "ogre"],
	groudon: ["Grou", "don"],
	rayquaza: ["Ray", "quaza"],
	jirachi: ["Ji", "rachi"],
	deoxys: ["Deo", "xys"],
	turtwig: ["Turt", "wig"],
	grotle: ["Gro", "otle"],
	torterra: ["Tort", "terra"],
	chimchar: ["Chim", "char"],
	monferno: ["Mon", "ferno"],
	infernape: ["Infern", "nape"],
	piplup: ["Pip", "lup"],
	prinplup: ["Prin", "plup"],
	empoleon: ["Empo", "leon"],
	starly: ["Starl", "arly"],
	staravia: ["Starav", "avia"],
	staraptor: ["Starap", "raptor"],
	bidoof: ["Bid", "doof"],
	bibarel: ["Biba", "rel"],
	kricketot: ["Kri", "ketot"],
	kricketune: ["Kricke", "tune"],
	shinx: ["Shi", "nx"],
	luxio: ["Lu", "xio"],
	luxray: ["Lux", "ray"],
	budew: ["Bu", "dew"],
	roserade: ["Rose", "rade"],
	cranidos: ["Cran", "idos"],
	rampardos: ["Ramp", "pardos"],
	shieldon: ["Shield", "don"],
	bastiodon: ["Bastio", "don"],
	burmy: ["Bur", "my"],
	wormadam: ["Worma", "dam"],
	mothim: ["Moth", "thim"],
	combee: ["Comb", "bee"],
	vespiquen: ["Vesp", "quen"],
	pachirisu: ["Pachi", "risu"],
	buizel: ["Bui", "zel"],
	floatzel: ["Float", "atzel"],
	cherubi: ["Cher", "rubi"],
	cherrim: ["Cherri", "rim"],
	shellos: ["Shell", "los"],
	gastrodon: ["Gastro", "trodon"],
	ambipom: ["Ambi", "pom"],
	drifloon: ["Drifl", "loon"],
	drifblim: ["Drifb", "blim"],
	buneary: ["Bun", "eary"],
	lopunny: ["Lop", "punny"],
	mismagius: ["Miss ", "magius"],
	honchkrow: ["Honch", "krow"],
	glameow: ["Glam", "meow"],
	purugly: ["Pur", "ugly"],
	chingling: ["Ching", "ling"],
	stunky: ["Stunk", "unky"],
	skuntank: ["Skunt", "tank"],
	bronzor: ["Bron", "zor"],
	bronzong: ["Bronz", "zong"],
	bonsly: ["Bon", "sly"],
	mimejr: ["Mime", " Jr."],
	happiny: ["Happi", "piny"],
	chatot: ["Chat", "tot"],
	spiritomb: ["Spiri", "tomb"],
	gible: ["Gib", "ble"],
	gabite: ["Gab", "bite"],
	garchomp: ["Gar", "chomp"],
	munchlax: ["Munch", "lax"],
	riolu: ["Rio", "olu"],
	lucario: ["Luca", "cario"],
	hippopotas: ["Hip", "potas"],
	hippowdon: ["Hippo", "powdon"],
	skorupi: ["Sko", "rupi"],
	drapion: ["Drap", "ion"],
	croagunk: ["Croa", "gunk"],
	toxicroak: ["Toxi", "croak"],
	carnivine: ["Carni", "vine"],
	finneon: ["Finn", "neon"],
	lumineon: ["Lumin", "ineon"],
	mantyke: ["Man", "tyke"],
	snover: ["Snov", "ver"],
	abomasnow: ["Aboma", "snow"],
	weavile: ["Weav", "vile"],
	magnezone: ["Magne", "zone"],
	lickilicky: ["Licki", "licky"],
	rhyperior: ["Rhy", "perior"],
	tangrowth: ["Tan", "growth"],
	electivire: ["Electi", "vire"],
	magmortar: ["Magmor", "mortar"],
	togekiss: ["Toge", "kiss"],
	yanmega: ["Yan", "mega"],
	leafeon: ["Leaf", "feon"],
	glaceon: ["Glace", "ceon"],
	gliscor: ["Glis", "cor"],
	mamoswine: ["Mamo", "swine"],
	porygonz: ["Pory", "gon-Z"],
	gallade: ["Gall", "lade"],
	probopass: ["Probo", "pass"],
	dusknoir: ["Dusk", "noir"],
	froslass: ["Fros", "lass"],
	rotom: ["Ro", "tom"],
	uxie: ["Ux", "xie"],
	mesprit: ["Mes", "sprit"],
	azelf: ["Aze", "elf"],
	dialga: ["Dial", "alga"],
	palkia: ["Palk", "kia"],
	heatran: ["Heat", "tran"],
	regigigas: ["Regi", "gigas"],
	giratina: ["Gira", "tina"],
	cresselia: ["Cress", "selia"],
	phione: ["Phio", "one"],
	manaphy: ["Mana", "phy"],
	darkrai: ["Dark", "rai"],
	shaymin: ["Shay", "min"],
	arceus: ["Arc", "ceus"],
	victini: ["Vict", "tini"],
	snivy: ["Sni", "vy"],
	servine: ["Serv", "ine"],
	serperior: ["Serpe", "rior"],
	tepig: ["Te", "epig"],
	pignite: ["Pig", "ignite"],
	emboar: ["Emb", "boar"],
	oshawott: ["Osha", "awott"],
	dewott: ["De", "ewott"],
	samurott: ["Samu", "rott"],
	patrat: ["Pat", "rat"],
	watchog: ["Watch", "hog"],
	lillipup: ["Lill", "pup"],
	herdier: ["Herd", "erdier"],
	stoutland: ["Stout", "land"],
	purrloin: ["Purr", "loin"],
	liepard: ["Lie", "pard"],
	pansage: ["Pans", "ansage"],
	simisage: ["Sim", "misage"],
	pansear: ["Panse", "ansear"],
	simisear: ["Simis", "misear"],
	panpour: ["Panp", "pour"],
	simipour: ["Simip", "mipour"],
	munna: ["Mun", "na"],
	musharna: ["Mush", "sharna"],
	pidove: ["Pido", "dove"],
	tranquill: ["Tranq", "quill"],
	unfezant: ["Unfe", "zant"],
	blitzle: ["Blitz", "itzle"],
	zebstrika: ["Zeb", "strika"],
	roggenrola: ["Roggen", "rola"],
	boldore: ["Bold", "dore"],
	gigalith: ["Giga", "lith"],
	woobat: ["Woob", "obat"],
	swoobat: ["Swoo", "bat"],
	drilbur: ["Drill", "bur"],
	excadrill: ["Exca", "cadrill"],
	audino: ["Aud", "dino"],
	timburr: ["Tim", "burr"],
	gurdurr: ["Gur", "durr"],
	conkeldurr: ["Conkel", "eldurr"],
	tympole: ["Tym", "pole"],
	palpitoad: ["Palpi", "pitoad"],
	seismitoad: ["Seismi", "mitoad"],
	throh: ["Thr", "roh"],
	sawk: ["Sa", "awk"],
	sewaddle: ["Sewa", "waddle"],
	swadloon: ["Swad", "adloon"],
	leavanny: ["Leav", "vanny"],
	venipede: ["Veni", "pede"],
	whirlipede: ["Whirli", "pede"],
	scolipede: ["Scoli", "pede"],
	cottonee: ["Cotton", "onee"],
	whimsicott: ["Whimsi", "cott"],
	petilil: ["Peti", "lil"],
	lilligant: ["Lilli", "gant"],
	basculin: ["Bascu", "lin"],
	sandile: ["Sandi", "ile"],
	krokorok: ["Kroko", "rok"],
	krookodile: ["Krooko", "dile"],
	darumaka: ["Daru", "maka"],
	darmanitan: ["Darman", "nitan"],
	maractus: ["Marac", "actus"],
	dwebble: ["Dweb", "ebble"],
	crustle: ["Crust", "ustle"],
	scraggy: ["Scrag", "aggy"],
	scrafty: ["Scraft", "afty"],
	sigilyph: ["Sigi", "lyph"],
	yamask: ["Ya", "mask"],
	cofagrigus: ["Cofag", "grigus"],
	tirtouga: ["Tirt", "touga"],
	carracosta: ["Carra", "costa"],
	archen: ["Arch", "chen"],
	archeops: ["Arche", "cheops"],
	trubbish: ["Trub", "bish"],
	garbodor: ["Garb", "odor"],
	zorua: ["Zo", "rua"],
	zoroark: ["Zoro", "ark"],
	minccino: ["Minc", "cino"],
	cinccino: ["Cinc", "ccino"],
	gothita: ["Goth", "ita"],
	gothorita: ["Gotho", "rita"],
	gothitelle: ["Gothi", "telle"],
	solosis: ["Solo", "sis"],
	duosion: ["Duo", "sion"],
	reuniclus: ["Reuni", "niclus"],
	ducklett: ["Duck", "lett"],
	swanna: ["Swan", "anna"],
	vanillite: ["Vani", "lite"],
	vanillish: ["Vanil", "lish"],
	vanilluxe: ["Vanill", "luxe"],
	deerling: ["Deer", "erling"],
	sawsbuck: ["Saw", "buck"],
	emolga: ["Emol", "olga"],
	karrablast: ["Karra", "blast"],
	escavalier: ["Esca", "valier"],
	foongus: ["Foon", "gus"],
	amoonguss: ["Amoon", "guss"],
	frillish: ["Frill", "illish"],
	jellicent: ["Jelli", "cent"],
	alomomola: ["Alomo", "mola"],
	joltik: ["Jolti", "tik"],
	galvantula: ["Galvan", "tula"],
	ferroseed: ["Ferros", "seed"],
	ferrothorn: ["Ferrot", "thorn"],
	klink: ["Kli", "ink"],
	klang: ["Kla", "ang"],
	klinklang: ["Klink", "klang"],
	tynamo: ["Tyna", "amo"],
	eelektrik: ["Eel", "lektrik"],
	eelektross: ["Eelek", "tross"],
	elgyem: ["Elg", "gyem"],
	beheeyem: ["Behe", "eyem"],
	litwick: ["Lit", "wick"],
	lampent: ["Lamp", "pent"],
	chandelure: ["Chandel", "lure"],
	axew: ["Axe", "xew"],
	fraxure: ["Frax", "xure"],
	haxorus: ["Hax", "xorus"],
	cubchoo: ["Cub", "choo"],
	beartic: ["Bear", "artic"],
	cryogonal: ["Cryo", "gonal"],
	shelmet: ["Shelm", "met"],
	accelgor: ["Accel", "elgor"],
	stunfisk: ["Stun", "fisk"],
	mienfoo: ["Mie", "foo"],
	mienshao: ["Mien", "shao"],
	druddigon: ["Druddi", "digon"],
	golett: ["Gole", "olett"],
	golurk: ["Golu", "lurk"],
	pawniard: ["Pawn", "iard"],
	bisharp: ["Bi", "sharp"],
	bouffalant: ["Bouf", "falant"],
	rufflet: ["Ruff", "ufflet"],
	braviary: ["Brav", "viary"],
	vullaby: ["Vull", "laby"],
	mandibuzz: ["Mandi", "buzz"],
	heatmor: ["Heatmo", "eatmor"],
	durant: ["Dur", "ant"],
	deino: ["Dei", "no"],
	zweilous: ["Zwei", "lous"],
	hydreigon: ["Hy", "dreigon"],
	larvesta: ["Larv", "esta"],
	volcarona: ["Volca", "rona"],
	cobalion: ["Cobal", "lion"],
	terrakion: ["Terra", "kion"],
	virizion: ["Viri", "zion"],
	tornadus: ["Tornad", "us"],
	thundurus: ["Thund", "urus"],
	reshiram: ["Reshi", "ram"],
	zekrom: ["Zek", "rom"],
	landorus: ["Land", "orus"],
	kyurem: ["Kyu", "rem"],
	keldeo: ["Kel", "deo"],
	meloetta: ["Melo", "etta"],
	genesect: ["Gene", "esect"],
	chespin: ["Chesp", "spin"],
	quilladin: ["Quill", "ladin"],
	chesnaught: ["Chesn", "naught"],
	fennekin: ["Fenne", "kin"],
	braixen: ["Braix", "xen"],
	delphox: ["Delph", "phox"],
	froakie: ["Froa", "kie"],
	frogadier: ["Froga", "dier"],
	greninja: ["Gren", "ninja"],
	bunnelby: ["Bunnel", "elby"],
	diggersby: ["Diggers", "ersby"],
	fletchling: ["Fletch", "ling"],
	fletchinder: ["Fletch", "inder"],
	talonflame: ["Talon", "flame"],
	scatterbug: ["Scatter", "erbug"],
	spewpa: ["Spew", "pa"],
	vivillon: ["Vivi", "villon"],
	litleo: ["Litle", "itleo"],
	pyroar: ["Pyro", "yroar"],
	flabebe: ["Flab\u00e9", "b\u00e9b\u00e9"],
	floette: ["Flo", "loette"],
	florges: ["Florg", "orges"],
	skiddo: ["Skid", "kiddo"],
	gogoat: ["Gogo", "goat"],
	pancham: ["Panch", "ancham"],
	pangoro: ["Pango", "goro"],
	furfrou: ["Furf", "frou"],
	espurr: ["Espu", "purr"],
	meowstic: ["Meows", "stic"],
	honedge: ["Hon", "edge"],
	doublade: ["Doub", "blade"],
	aegislash: ["Aegi", "slash"],
	spritzee: ["Spritz", "itzee"],
	aromatisse: ["Aroma", "tisse"],
	swirlix: ["Swirl", "irlix"],
	slurpuff: ["Slurp", "urpuff"],
	inkay: ["Ink", "kay"],
	malamar: ["Mala", "lamar"],
	binacle: ["Bin", "nacle"],
	barbaracle: ["Barbar", "racle"],
	skrelp: ["Skre", "relp"],
	dragalge: ["Dragal", "galge"],
	clauncher: ["Claunch", "auncher"],
	clawitzer: ["Claw", "witzer"],
	helioptile: ["Heliop", "optile"],
	heliolisk: ["Heliol", "olisk"],
	tyrunt: ["Ty", "runt"],
	tyrantrum: ["Tyran", "trum"],
	amaura: ["Ama", "aura"],
	aurorus: ["Auro", "rorus"],
	sylveon: ["Syl", "veon"],
	hawlucha: ["Hawl", "lucha"],
	dedenne: ["Deden", "denne"],
	carbink: ["Carb", "bink"],
	goomy: ["Goo", "my"],
	sliggoo: ["Sli", "goo"],
	goodra: ["Goo", "dra"],
	klefki: ["Klef", "ki"],
	phantump: ["Phant", "tump"],
	trevenant: ["Tre", "venant"],
	pumpkaboo: ["Pump", "kaboo"],
	gourgeist: ["Gourg", "urgeist"],
	bergmite: ["Berg", "mite"],
	avalugg: ["Ava", "lugg"],
	noibat: ["Noi", "bat"],
	noivern: ["Noi", "vern"],
	xerneas: ["Xern", "neas"],
	yveltal: ["Yvel", "veltal"],
	zygarde: ["Zyga", "garde"],
	diancie: ["Dian", "ancie"],
	hoopa: ["Hoop", "oopa"],
	volcanion: ["Volcan", "canion"],
	rowlet: ["Rowl", "owlet"],
	dartrix: ["Dart", "trix"],
	decidueye: ["Decidu", "dueye"],
	litten: ["Litte", "itten"],
	torracat: ["Torra", "cat"],
	incineroar: ["Incine", "cineroar"],
	popplio: ["Popp", "plio"],
	brionne: ["Brion", "onne"],
	primarina: ["Prima", "marina"],
	pikipek: ["Piki", "pek"],
	trumbeak: ["Trum", "beak"],
	toucannon: ["Touca", "cannon"],
	yungoos: ["Yung", "goos"],
	gumshoos: ["Gum", "shoos"],
	grubbin: ["Grub", "bin"],
	charjabug: ["Charja", "abug"],
	vikavolt: ["Vika", "volt"],
	crabrawler: ["Crab", "brawler"],
	crabominable: ["Crabo", "ominable"],
	oricorio: ["Ori", "corio"],
	cutiefly: ["Cutie", "tiefly"],
	ribombee: ["Ribom", "bombee"],
	rockruff: ["Rock", "ruff"],
	lycanroc: ["Lycan", "roc"],
	wishiwashi: ["Wishi", "washi"],
	mareanie: ["Mar", "eanie"],
	toxapex: ["Tox", "apex"],
	mudbray: ["Mudb", "bray"],
	mudsdale: ["Muds", "dale"],
	dewpider: ["Dew", "pider"],
	araquanid: ["Ara", "quanid"],
	fomantis: ["Fo", "mantis"],
	lurantis: ["Lur", "antis"],
	morelull: ["More", "lull"],
	shiinotic: ["Shii", "notic"],
	salandit: ["Salan", "dit"],
	salazzle: ["Sal", "azzle"],
	stufful: ["Stuff", "ful"],
	bewear: ["Be", "wear"],
	bounsweet: ["Bouns", "sweet"],
	steenee: ["Stee", "nee"],
	tsareena: ["Tsar", "eena"],
	comfey: ["Com", "fey"],
	oranguru: ["Oran", "guru"],
	passimian: ["Pass", "simian"],
	wimpod: ["Wimp", "pod"],
	golisopod: ["Goliso", "sopod"],
	sandygast: ["Sandy", "gast"],
	palossand: ["Palo", "sand"],
	pyukumuku: ["Pyuku", "muku"],
	typenull: ["Type:", " Null"],
	silvally: ["Silv", "ally"],
	minior: ["Mini", "or"],
	komala: ["Koma", "mala"],
	turtonator: ["Turto", "nator"],
	togedemaru: ["Tegede", "maru"],
	mimikyu: ["Mimi", "kyu"],
	bruxish: ["Brux", "ish"],
	drampa: ["Dram", "ampa"],
	dhelmise: ["Dhelm", "helmise"],
	jangmoo: ["Jang", "angmo-o"],
	hakamoo: ["Haka", "akamo-o"],
	kommoo: ["Komm", "mo-o"],
	tapukoko: ["Tapu Ko", " Koko"],
	tapulele: ["Tapu Le", " Lele"],
	tapubulu: ["Tapu Bu", " Bulu"],
	tapufini: ["Tapu Fi", " Fini"],
	cosmog: ["Cos", "smog"],
	cosmoem: ["Cosmo", "em"],
	solgaleo: ["Solga", "galeo"],
	lunala: ["Lun", "ala"],
	nihilego: ["Nihi", "lego"],
	buzzwole: ["Buzz", "zwole"],
	pheromosa: ["Phero", "mosa"],
	xurkitree: ["Xurkit", "kitree"],
	celesteela: ["Celeste", "steela"],
	kartana: ["Kart", "tana"],
	guzzlord: ["Guzz", "lord"],
	necrozma: ["Necro", "zma"],
	magearna: ["Magear", "gearna"],
	marshadow: ["Marsha", "shadow"],
	poipole: ["Poip", "ole"],
	naganadel: ["Naga", "nadel"],
	stakataka: ["Staka", "taka"],
	blacephalon: ["Blace", "phalon"],
	zeraora: ["Zera", "ora"],
	meltan: ["Melt", "tan"],
	melmetal: ["Mel", "metal"],
	grookey: ["Groo", "ookey"],
	thwackey: ["Thwack", "ckey"],
	rillaboom: ["Rilla", "boom"],
	scorbunny: ["Scor", "bunny"],
	raboot: ["Rab", "boob"],
	cinderace: ["Cinder", "ace"],
	sobble: ["Sob", "obble"],
	drizzile: ["Drizz", "zile"],
	inteleon: ["Intel", "eleon"],
	skwovet: ["Skwo", "ovet"],
	greedent: ["Greed", "dent"],
	rookidee: ["Rooki", "dee"],
	corvisquire: ["Corvis", "squire"],
	corviknight: ["Corvik", "knight"],
	blipbug: ["Blip", "lipbug"],
	dottler: ["Dott", "ottler"],
	orbeetle: ["Orbee", "beetle"],
	nickit: ["Nick", "kit"],
	thievul: ["Thiev", "vul"],
	gossifleur: ["Gossi", "fleur"],
	eldegoss: ["Elde", "goss"],
	wooloo: ["Wool", "loo"],
	dubwool: ["Dub", "wool"],
	chewtle: ["Chew", "ewtle"],
	drednaw: ["Dred", "ednaw"],
	yamper: ["Yamp", "amper"],
	boltund: ["Bolt", "tund"],
	rolycoly: ["Roly", "coly"],
	carkol: ["Cark", "arkol"],
	coalossal: ["Coal", "lossal"],
	applin: ["App", "plin"],
	flapple: ["Flapp", "apple"],
	appletun: ["Apple", "tun"],
	silicobra: ["Sili", "cobra"],
	sandaconda: ["Sanda", "aconda"],
	cramorant: ["Cramo", "morant"],
	arrokuda: ["Arro", "rokuda"],
	barraskewda: ["Barra", "skewda"],
	toxel: ["Toxe", "xel"],
	toxtricity: ["Toxtri", "tricity"],
	sizzlipede: ["Sizzli", "zlipede"],
	centiskorch: ["Centi", "skorch"],
	clobbopus: ["Clobbo", "pus"],
	grapploct: ["Grapp", "ploct"],
	sinistea: ["Sinis", "tea"],
	polteageist: ["Poltea", "teageist"],
	hatenna: ["Hat", "tenna"],
	hattrem: ["Hatt", "trem"],
	hatterene: ["Hatte", "rene"],
	impidimp: ["Impi", "dimp"],
	morgrem: ["Mor", "grem"],
	grimmsnarl: ["Grimm", "snarl"],
	obstagoon: ["Obsta", "goon"],
	perrserker: ["Perr", "serker"],
	cursola: ["Curs", "ursola"],
	sirfetchd: ["Sir", "irfetch'd"],
	mrrime: ["Mr. R", " Rime"],
	runerigus: ["Rune", "erigus"],
	milcery: ["Milc", "cery"],
	alcremie: ["Alcre", "cremie"],
	falinks: ["Fal", "links"],
	pincurchin: ["Pinc", "curchin"],
	snom: ["Sn", "nom"],
	frosmoth: ["Frosmo", "osmoth"],
	stonjourner: ["Ston", "journer"],
	eiscue: ["Eis", "cue"],
	indeedee: ["Indeed", "deedee"],
	morpeko: ["Morp", "peko"],
	cufant: ["Cuf", "fant"],
	copperajah: ["Copper", "rajah"],
	dracozolt: ["Dracoz", "cozolt"],
	arctozolt: ["Arctoz", "tozolt"],
	dracovish: ["Dracov", "covish"],
	arctovish: ["Arctov", "tovish"],
	duraludon: ["Dura", "ludon"],
	dreepy: ["Dreep", "eepy"],
	drakloak: ["Drak", "kloak"],
	dragapult: ["Draga", "pult"],
	zacian: ["Zaci", "cian"],
	zamazenta: ["Zama", "zenta"],
	eternatus: ["Eterna", "natus"],
	kubfu: ["Kub", "fu"],
	urshifu: ["Urshi", "shifu"],
	zarude: ["Zaru", "rude"],
	regieleki: ["Regie", "leki"],
	regidrago: ["Regid", "drago"],
	glastrier: ["Glast", "strier"],
	spectrier: ["Spect", "ctrier"],
	calyrex: ["Caly", "rex"],
	wyrdeer: ["Wyr", "deer"],
	kleavor: ["Kleav", "vor"],
	ursaluna: ["Ursa", "luna"],
	basculegion: ["Bascu", "legion"],
	sneasler: ["Sneas", "sler"],
	overqwil: ["Over", "qwil"],
	enamorus: ["Enamo", "morus"],
	sprigatito: ["Spriga", "gatito"],
	floragato: ["Flora", "gato"],
	meowscarada: ["Meow", "scarada"],
	fuecoco: ["Fue", "coco"],
	crocalor: ["Croc", "calor"],
	skeledirge: ["Skele", "dirge"],
	quaxly: ["Quax", "ly"],
	quaxwell: ["Quax", "well"],
	quaquaval: ["Quaqua", "quaval"],
	lechonk: ["Le", "chonk"],
	oinkologne: ["Oink", "kologne"],
	tarountula: ["Taroun", "tula"],
	spidops: ["Spi", "dops"],
	nymble: ["Nym", "ble"],
	lokix: ["Lo", "kix"],
	pawmi: ["Paw", "mi"],
	pawmo: ["Paw", "mo"],
	pawmot: ["Paw", "mot"],
	tandemaus: ["Tande", "maus"],
	maushold: ["Maus", "hold"],
	fidough: ["Fi", "dough"],
	dachsbun: ["Dachs", "bun"],
	smoliv: ["Smol", "liv"],
	dolliv: ["Doll", "liv"],
	arboliva: ["Arbol", "liva"],
	squawkabilly: ["Squawk", "abilly"],
	nacli: ["Nac", "li"],
	naclstack: ["Nacl", "stack"],
	garganacl: ["Garga", "nacl"],
	charcadet: ["Char", "cadet"],
	armarouge: ["Arma", "rouge"],
	ceruledge: ["Cerul", "edge"],
	tadbulb: ["Tad", "bulb"],
	bellibolt: ["Belli", "bolt"],
	wattrel: ["Watt", "rel"],
	kilowattrel: ["Kilowatt", "wattrel"],
	maschiff: ["Masch", "schiff"],
	mabosstiff: ["Maboss", "stiff"],
	shroodle: ["Shroo", "roodle"],
	grafaiai: ["Graf", "aiai"],
	bramblin: ["Brambl", "blin"],
	brambleghast: ["Bramble", "ghast"],
	toedscool: ["Toeds", "cool"],
	toedscruel: ["Toeds", "cruel"],
	klawf: ["Klaw", "awf"],
	capsakid: ["Capsa", "kid"],
	scovillain: ["Scovill", "villain"],
	rellor: ["Rel", "lor"],
	rabsca: ["Rab", "sca"],
	flittle: ["Flit", "ittle"],
	espathra: ["Espa", "thra"],
	tinkatink: ["Tinka", "tink"],
	tinkatuff: ["Tinka", "tuff"],
	tinkaton: ["Tinka", "ton"],
	wiglett: ["Wig", "lett"],
	wugtrio: ["Wug", "trio"],
	bombirdier: ["Bombird", "dier"],
	finizen: ["Fini", "zen"],
	palafin: ["Pala", "fin"],
	varoom: ["Var", "room"],
	revavroom: ["Revav", "vroom"],
	cyclizar: ["Cycli", "zar"],
	orthworm: ["Orth", "worm"],
	glimmet: ["Glimm", "met"],
	glimmora: ["Glimm", "mora"],
	greavard: ["Greav", "vard"],
	houndstone: ["Hound", "stone"],
	flamigo: ["Flam", "amigo"],
	cetoddle: ["Ceto", "toddle"],
	cetitan: ["Ceti", "tan"],
	veluza: ["Velu", "luza"],
	dondozo: ["Dondo", "dozo"],
	tatsugiri: ["Tatsu", "giri"],
	annihilape: ["Annihi", "lape"],
	clodsire: ["Clod", "sire"],
	farigiraf: ["Fari", "giraf"],
	dudunsparce: ["Dudun", "sparce"],
	kingambit: ["King", "gambit"],
	greattusk: ["Great ", "tusk"],
	screamtail: ["Scream ", "tail"],
	brutebonnet: ["Brute ", "bonnet"],
	fluttermane: ["Flutter ", "mane"],
	slitherwing: ["Slither ", "wing"],
	sandyshocks: ["Sandy ", "shocks"],
	irontreads: ["Iron ", "treads"],
	ironbundle: ["Iron ", "bundle"],
	ironhands: ["Iron ", "hands"],
	ironjugulis: ["Iron ", "jugulis"],
	ironmoth: ["Iron ", "moth"],
	ironthorns: ["Iron ", "thorns"],
	frigibax: ["Frigi", "bax"],
	arctibax: ["Arcti", "bax"],
	baxcalibur: ["Bax", "calibur"],
	gimmighoul: ["Gimmi", "ghoul"],
	gholdengo: ["Ghold", "dengo"],
	wochien: ["Wo-", "-Chien"],
	chienpao: ["Chien-", "-Pao"],
	tinglu: ["Ting-", "-Lu"],
	chiyu: ["Chi-", "-Yu"],
	roaringmoon: ["Roaring ", "moon"],
	ironvaliant: ["Iron ", "valiant"],
	koraidon: ["Korai", "don"],
	miraidon: ["Mirai", "don"],
	walkingwake: ["Walking ", "wake"],
	ironleaves: ["Iron ", "leaves"],
	dipplin: ["Dipp", "plin"],
	poltchageist: ["Poltcha", "geist"],
	sinistcha: ["Sinist", "tcha"],
	okidogi: ["Oki", "dogi"],
	munkidori: ["Munki", "dori"],
	fezandipiti: ["Fezan", "dipiti"],
	ogerpon: ["Oger", "pon"],
	archaludon: ["Archa", "don"],
	hydrapple: ["Hydr", "apple"],
	gougingfire: ["Gouging ", "fire"],
	ragingbolt: ["Raging ", "bolt"],
	ironboulder: ["Iron ", "boulder"],
	ironcrown: ["Iron ", "crown"],
	terapagos: ["Tera", "pagos"],
	pecharunt: ["Pecha", "runt"],

	// CAP
	missingno: ["Missing ", " no."],
	syclar: ["Syc", "lar"],
	syclant: ["Syc", "lant"],
	revenankh: ["Reve", "nankh"],
	embirch: ["Em", "birch"],
	flarelm: ["Flar", "elm"],
	pyroak: ["Py", "roak"],
	breezi: ["Bree", "zi"],
	fidgit: ["Fid", "git"],
	rebble: ["Reb", "ble"],
	tactite: ["Tac", "tite"],
	stratagem: ["Strata", "gem"],
	privatyke: ["Priva", "tyke"],
	arghonaut: ["Argho", "naut"],
	kitsunoh: ["Kitsu", "noh"],
	cyclohm: ["Cyc", "lohm"],
	colossoil: ["Colos", "soil"],
	krilowatt: ["Krilo", "watt"],
	voodoll: ["Voo", "doll"],
	voodoom: ["Voo", "doom"],
	scratchet: ["Scrat", "chet"],
	tomohawk: ["Tomo", "hawk"],
	necturine: ["Nectu", "rine"],
	necturna: ["Nectur", "na"],
	mollux: ["Mol", "lux"],
	cupra: ["Cu", "pra"],
	argalis: ["Arga", "lis"],
	aurumoth: ["Auru", "moth"],
	brattler: ["Bratt", "ler"],
	malaconda: ["Mala", "conda"],
	cawdet: ["Caw", "det"],
	cawmodore: ["Caw", "modore"],
	volkritter: ["Vol", "kritter"],
	volkraken: ["Vol", "kraken"],
	snugglow: ["Snug", "glow"],
	plasmanta: ["Plas", "manta"],
	floatoy: ["Floa", "toy"],
	caimanoe: ["Cai", "manoe"],
	naviathan: ["Navia", "than"],
	crucibelle: ["Cruci", "belle"],
	pluffle: ["Plu", "ffle"],
	kerfluffle: ["Kerflu", "ffle"],
	pajantom: ["Pajan", "tom"],
	mumbao: ["Mum", "bao"],
	jumbao: ["Jum", "bao"],
	fawnifer: ["Fawn", "ifer"],
	electrelk: ["Elect", "relk"],
	caribolt: ["Cari", "bolt"],
	smogecko: ["Smo", "gecko"],
	smoguana: ["Smo", "guana"],
	smokomodo: ["Smo", "komodo"],
	swirlpool: ["Swirl", "pool"],
	coribalis: ["Cori", "balis"],
	snaelstrom: ["Snael", "strom"],
	justyke: ["Jus", "tyke"],
	equilibra: ["Equi", "libra"],
	solotl: ["Sol", "lotl"],
	astrolotl: ["Astro", "lotl"],
	miasmite: ["Mias", "mite"],
	miasmaw: ["Mias", "maw"],
	chromera: ["Chro", "mera"],
	nohface: ["Noh", "face"],
	monohm: ["Mon", "ohm"],
	duohm: ["Duo", "ohm"],
	dorsoil: ["Dor", "soil"],
	protowatt: ["Proto", "watt"],
	venomicon: ["Veno", "micon"],
	saharascal: ["Saha", "rascal"],
	saharaja: ["Saha", "raja"],
	ababo: ["Aba", "abo"],
	scattervein: ["Scatter", "vein"],
	hemogoblin: ["Hemo", "goblin"],
	cresceidon: ["Cres", "ceidon"],
	chuggalong: ["Chugga", "long"],
	shox: ["Sho", "ox"],

	// INSURGENCE
	ufi: ["Uf", "fi"],

	// URANIUM
	birbie: ["Bir", "bie"],
	aveden: ["Ave", "den"],
	splendifowl: ["Splendi", "fowl"],
	cubbug: ["Cub", "bug"],
	cubblfly: ["Cubbl", "fly"],
	nimflora: ["Nim", "flora"],
	barewl: ["Bar", "ewl"],
	dearewl: ["Dear", "ewl"],
	gararewl: ["Garar", "ewl"],
	grozard: ["Gro", "zard"],
	terlard: ["Ter", "lard"],
	tonemy: ["Ton", "emy"],
	tofurang: ["Tofu", "rang"],
	dunseraph: ["Dun", "seraph"],
	fortog: ["For", "tog"],
	folerog: ["Fole", "rog"],
	blubelrog: ["Blubel", "rog"],
	feleng: ["Fel", "leng"],
	felunge: ["Fel", "lunge"],
	feliger: ["Fel", "liger"],
	empirilla: ["Empi", "rilla"],
	owten: ["Ow", "ten"],
	eshouten: ["Eshou", "ten"],
	smore: ["Smo", "ore"],
	firoke: ["Firo", "ke"],
	brailip: ["Brail", "lip"],
	brainoar: ["Brain", "noar"],
	tancoon: ["Tan", "coon"],
	tanscure: ["Tan", "scure"],
	sponee: ["Spo", "nee"],
	sponaree: ["Spona", "ree"],
	pahar: ["Pa", "har"],
	palij: ["Pa", "lij"],
	pajay: ["Pa", "jay"],
	jerbolta: ["Jer", "bolta"],
	comite: ["Co", "mite"],
	cometeor: ["Co", "meteor"],
	astronite: ["Astro", "nite"],
	baashaun: ["Baa", "shaun"],
	baaschaf: ["Baa", "schaf"],
	baariette: ["Baa", "riette"],
	tricwe: ["Tric", "we"],
	harylect: ["Hary", "lect"],
	costraw: ["Cost", "raw"],
	trawpint: ["Traw", "pint"],
	lunapup: ["Luna", "pup"],
	herolune: ["Hero", "lune"],
	minyan: ["Min", "yan"],
	vilucard: ["Vilu", "card"],
	modrille: ["Mod", "rille"],
	drilgann: ["Dril", "gann"],
	cocaran: ["Coca", "ran"],
	cararalm: ["Cara", "ralm"],
	cocancer: ["Cocan", "cer"],
	corsoreef: ["Corso", "reef"],
	tubjaw: ["Tub", "jaw"],
	tubareel: ["Tuba", "reel"],
	cassnail: ["Cass", "nail"],
	sableau: ["Sab", "leau"],
	escartress: ["Escar", "tress"],
	nupin: ["Nu", "pin"],
	gellin: ["Gel", "lin"],
	barand: ["Ba", "rand"],
	glaslug: ["Glas", "lug"],
	glavinug: ["Glavi", "nug"],
	s51: ["S5-", "-51"],
	s51a: ["S5-", "-51A"],
	paraudio: ["Par", "audio"],
	paraboom: ["Para", "boom"],
	flager: ["Fla", "ager"],
	inflagetah: ["Infla", "getah"],
	chimical: ["Chimi", "cal"],
	chimaconda: ["Chima", "conda"],
	tikiki: ["Tiki", "ki"],
	frikitiki: ["Friki", "tiki"],
	unymph: ["Un", "nymph"],
	harptera: ["Harp", "tera"],
	chicoatl: ["Chico", "atl"],
	quetzoral: ["quetzo", "ral"],
	coatlith: ["Coat", "lith"],
	tracton: ["Trac", "ton"],
	snopach: ["Sno", "pach"],
	dermafrost: ["Derma", "frost"],
	slothohm: ["Sloth", "ohm"],
	theriamp: ["Theri", "amp"],
	titanice: ["Titan", "ice"],
	frynai: ["Fry", "nai"],
	saidine: ["Sai", "dine"],
	daikatuna: ["Daika", "tuna"],
	selkid: ["Sel", "kid"],
	syrentide: ["Syren", "tide"],
	miasmedic: ["Mias", "medic"],
	jackdeary: ["Jack", "deary"],
	winotinger: ["Wino", "tinger"],
	duplicat: ["Dupli", "cat"],
	nucleon: ["Nuc", "leon"],
	ratsy: ["Rat", "sy"],
	raffiti: ["Raff", "iti"],
	gargryph: ["Gar", "gryph"],
	masking: ["Mas", "king"],
	dramsama: ["Dram", "sama"],
	antarki: ["Antar", "ki"],
	chupacho: ["Chup", "pacho"],
	luchabra: ["Lucha", "bra"],
	linkite: ["Link", "ite"],
	chainite: ["Chain", "ite"],
	pufluff: ["Puf", "fluff"],
	alpico: ["Al", "pico"],
	anderind: ["Ander", "ind"],
	colarva: ["Co", "larva"],
	frosulo: ["Fro", "sulo"],
	frosthra: ["Frosth", "ra"],
	fafurr: ["Fa", "furr"],
	fafninter: ["Faf", "ninter"],
	shrimputy: ["Shrimp", "uty"],
	krilvolver: ["Kril", "volver"],
	lavent: ["La", "vent"],
	swabone: ["Swa", "bone"],
	skelerogue: ["Skele", "rogue"],
	navighast: ["Navi", "ghast"],
	stenowatt: ["Steno", "watt"],
	jungore: ["Jung", "ore"],
	majungold: ["Majun", "gold"],
	hagoop: ["Ha", "goop"],
	haagross: ["Haa", "gross"],
	xenomite: ["Xeno", "mite"],
	xenogen: ["Xeno", "gen"],
	xenoqueen: ["Xeno", "queen"],
	hazma: ["Haz", "zma"],
	geigeroach: ["Geige", "roach"],
	minicorn: ["Mini", "corn"],
	kiricorn: ["Kiri", "corn"],
	oblivicorn: ["Oblivi", "corn"],
	luxi: ["Lux", "xi"],
	luxor: ["Lux", "xor"],
	luxelong: ["Luxe", "long"],
	praseopunk: ["Praseo", "punk"],
	neopunk: ["Neo", "punk"],
	sheebit: ["Shee", "bit"],
	terrabbit: ["Terra", "bbit"],
	laissure: ["Lais", "sure"],
	volchik: ["Vol", "chik"],
	voltasu: ["Vol", "tasu"],
	yatagaryu: ["Yata", "garyu"],
	devimp: ["Dev", "imp"],
	fallengel: ["Fallen", "gel"],
	beliaddon: ["Beli", "addon"],
	seikamater: ["Seika", "mater"],
	garlikid: ["Garli", "kid"],
	lanthan: ["Lan", "than"],
	actan: ["Ac", "tan"],
	urayne: ["Ur", "ayne"],

	// POA
	ashenash: ["Ashe", "nash"],
	alphbit: ["Alph", "bit"],
	anneliark: ["Anneli", "liark"],
	arcaspark: ["Arca", "spark"],
	aviotion: ["Avio", "tion"],
	bahamist: ["Baha", "mist"],
	barreko: ["Barre", "reko"],
	barrimander: ["Barri", "mander"],
	berserkergene: ["Berserker ", "gene"],
	betech: ["Bete", "tech"],
	bewitwing: ["Bewit", "wing"],
	braskeptic: ["Bras", "skeptic"],
	bohememoss: ["Boheme", "moss"],
	bunnor: ["Bun", "nor"],
	buntaki: ["Bun", "taki"],
	cactusplash: ["Cactu", "splash"],
	calobera: ["Calo", "bera"],
	caramitti: ["Cara", "mitti"],
	carcharus: ["Carch", "arus"],
	catastropede: ["Catastro", "pede"],
	catzelwyrm: ["Catzel", "wyrm"],
	celestray: ["Cele", "stray"],
	ceraguard: ["Cera", "guard"],
	chickix: ["Chic", "kix"],
	chocogrif: ["Choco", "grif"],
	chronobour: ["Chrono", "bour"],
	cloudinyte: ["Cloudi", "nyte"],
	conductree: ["Conduc", "tree"],
	crayzigater: ["Crayzi", "gater"],
	crenibex: ["Creni", "bex"],
	dangonna: ["Dan", "gonna"],
	dracat: ["Dra", "cat"],
	dracotion: ["Draco", "tion"],
	drifbozu: ["Drif", "bozu"],
	dryguaro: ["Dry", "guaro"],
	eggchell: ["Egg", "chell"],
	eidolburgh: ["Eidol", "burgh"],
	electrikitty: ["Electri", "kitty"],
	enchantobra: ["Enchan", "tobra"],
	escarphone: ["Escar", "phone"],
	eyespy: ["Eye", "spy"],
	feidan: ["Fei", "idan"],
	felapstan: ["Felap", "stan"],
	fonspring: ["Fons", "spring"],
	furumo: ["Furu", "rumo"],
	gelazura: ["Gela", "zura"],
	gilotherma: ["Gilo", "therma"],
	gluttini: ["Glutti", "tini"],
	grandmirage: ["Grand ", "mirage"],
	growlsome: ["Growl", "some"],
	guarig: ["Gua", "rig"],
	harportia: ["Harp", "portia"],
	hoppyre: ["Hopp", "pyre"],
	hydroupa: ["Hyd", "roupa"],
	icyall: ["Icy", "yall"],
	incandele: ["Incan", "dele"],
	imitotion: ["Imit", "totion"],
	ironchamber: ["Iron ", "chamber"],
	ironeverlasting: ["Iron ", "everlasting"],
	jawladin: ["Jaw", "ladin"],
	jovianshk: ["Jovi", "anshk"],
	kaleidleon: ["Kaleid", "leon"],
	keepurr: ["Keep", "purr"],
	lampsham: ["Lamp", "sham"],
	loxicant: ["Loxi", "cant"],
	lunachi: ["Luna", "chi"],
	maggony: ["Magg", "gony"],
	magiliar: ["Magi", "liar"],
	magnegauss: ["Magne", "gauss"],
	malamancer: ["Mala", "mancer"],
	matterpillar: ["Matter", "pillar"],
	manacra: ["Mana", "cra"],
	meditao: ["Medi", "tao"],
	mephistoxin: ["Mephis", "toxin"],
	miasmiss: ["Mias", "miss"],
	mjochiin: ["Mjo", "chinn"],
	mochimechi: ["Mochi", "mechi"],
	monetoad: ["Mone", "toad"],
	mosster: ["Moss", "ter"],
	nebulant: ["Nebu", "lant"],
	nestitan: ["Nes", "titan"],
	niandertroll: ["Niander", "troll"],
	nweet: ["Nwee", "weet"],
	ockthane: ["Ock", "thane"],
	omecha: ["Ome", "mecha"],
	othocket: ["Otho", "cket"],
	paldemaria: ["Palde", "maria"],
	pandiz: ["Pan", "diz"],
	parashukado: ["Parashu", "kado"],
	penumbralith: ["Penumb", "ralith"],
	pestri: ["Pes", "tri"],
	potermit: ["Poter", "mit"],
	premotee: ["Premo", "tee"],
	pupprodigy: ["Pupp", "prodigy"],
	rabbicicle: ["Rabbi", "cicle"],
	rakura: ["Raku", "kura"],
	regimyo: ["Regi", "myo"],
	reneguana: ["Rene", "guana"],
	rotomhisui: ["Roto", " Hisui"],
	rotomhisuiarmored: ["Roto", " Hisui-Armored"],
	saturoceras: ["Saturo", "ceras"],
	sauphozoa: ["Saupho", "zoa"],
	scaleslash: ["Scale", "slash"],
	scalyterror: ["Scaly ", "terror"],
	scorchingkiln: ["Scorching ", "kiln"],
	sekrilon: ["Sek", "rilon"],
	silretro: ["Sil", "retro"],
	sinistersickle: ["Sinister ", "sickle"],
	sirentom: ["Siren", "tom"],
	snowiibay: ["Snowii", "bay"],
	snowlet: ["Snow", "let"],
	snugglosis: ["Snugg", "losis"],
	soulply: ["Soul", "ply"],
	squice: ["Squi", "ice"],
	staruhz: ["Sta", "ruhz"],
	stratosting: ["Strato", "sting"],
	suenami: ["Sue", "nami"],
	sweepdol: ["Sweep", "dol"],
	tanukief: ["Tanu", "kief"],
	tinkashank: ["Tinka", "shank"],
	tinkaslice: ["Tinka", "slice"],
	tinkastab: ["Tinka", "stab"],
	twinova: ["Twi", "nova"],
	tofagrif: ["Tofa", "grif"],
	toxice: ["Tox", "ice"],
	treatern: ["Trea", "tern"],
	trickin: ["Tric", "kin"],
	tyranisacer: ["Tyrani", "sacer"],
	utensitile: ["Utensi", "tile"],
	varkacosm: ["Varka", "cosm"],
	voliable: ["Voli", "able"],
	whacksteroid: ["Whack", "steroid"],
	wrighvern: ["Wrigh", "vern"],
	wyvarice: ["Wyva", "rice"],
	zorblob: ["Zor", "blob"],

	// INFINITY
	lukpup: ["Luk", "pup"],
	lukagon: ["Luka", "gon"],
	kokiseed: ["Koki", "seed"],
	kokipound: ["Koki", "pound"],
	kokismash: ["Koki", "smash"],
	chargo: ["Char", "go"],
	burnaram: ["Burna", "ram"],
	psysteed: ["Psy", "steed"],
	darpole: ["Dar", "pole"],
	brutoad: ["Bru", "toad"],
	godfrogger: ["God", "frogger"],
	gorochu: ["Goro", "chu"],
	nidorook: ["Nido", "rook"],
	quezsparce: ["Quez", "sparce"],
	faeralynx: ["Faera", "lynx"],
	skulkraken: ["Skul", "kraken"],
	mukegho: ["Mu", "uk"],
	oozma: ["Ooz", "zma"],
	omeon: ["Om", "meon"],
	champeon: ["Champ", "peon"],
	lepideon: ["Lepi", "deon"],
	guardeon: ["Guar", "deon"],
	obsideon: ["Obsi", "deon"],
	scorpeon: ["Scor", "peon"],
	sphynxeon: ["Sphynx", "xeon"],
	nimbeon: ["Nim", "beon"],
	draconeon: ["Draco", "neon"],
	eeveeon: ["Eev", "eeon"],
	vareon: ["Var", "reon"],
	terathwack: ["Tera", "thwack"],
	grimfowl: ["Grim", "fowl"],
	sunflorid: ["Sun", "florid"],
	sorcerice: ["Sorcer", "ice"],
	kecleodon: ["Kecle", "odon"],
	wereyena: ["Were", "yena"],
	reaptide: ["Reap", "tide"],
	kidfoot: ["Kid", "foot"],
	snosquatch: ["Snos", "quatch"],
	grasquatch: ["Gras", "quatch"],
	arctusk: ["Arc", "tusk"],
	gigantusk: ["Gigan", "tusk"],
	iceros: ["Ice", "ros"],
	glacieros: ["Glacie", "ros"],
	mockroach: ["Mock", "roach"],
	jollibird: ["Jolli", "bird"],
	kablowfish: ["Kablow", "fish"],
	scalarva: ["Sca", "larva"],
	dragalis: ["Draga", "lis"],
	ceregal: ["Cere", "gal"],
	gargon: ["Gar", "gon"],
	wardern: ["Ward", "ern"],
	dragoyle: ["Dra", "goyle"],
	porygonx: ["Pory", "gon-X"],
	oculeus: ["Ocu", "leus"],
	arkhaos: ["Ark", "khaos"],
	botamon: ["Bota", "mon"],
	koromon: ["Koro", "mon"],
	agumon: ["Agu", "mon"],
	greymon: ["Grey", "mon"],
	metalgreymon: ["MetalGrey", "mon"],
	wargreymon: ["WarGrey", "mon"],
	tyrannomon: ["Tyranno", "mon"],
	skullgreymon: ["SkullGrey", "mon"],
	betamon: ["Beta", "mon"],
	seadramon: ["Seadra", "mon"],
	numemon: ["Nume", "mon"],
	viledoom: ["Vile", "doom"],
	mortossum: ["Morto", "ossum"],
	mushling: ["Mush", "ling"],
	psycholyte: ["Psycho", "lyte"],
	shroomage: ["Shroo", "mage"],
	calfpint: ["Calf", "pint"],
	arbird: ["Ar", "bird"],
	girafaraf: ["Gira", "faraf"],
	giragira: ["Gira", "gira"],
	whave: ["Wha", "ave"],
	orcabyss: ["Orca", "byss"],
	zapalope: ["Zapa", "lope"],
	joltalope: ["Jolta", "lope"],
	mewthree: ["Mew", "three"],
	palmon: ["Pal", "mon"],
	togemon: ["Toge", "mon"],
	shellmon: ["Shell", "mon"],
	tsunomon: ["Tsuno", "mon"],
	motimon: ["Moti", "mon"],
	gabumon: ["Gabu", "mon"],
	elecmon: ["Elec", "mon"],
	gomamon: ["Goma", "mon"],
	crabmon: ["Crab", "mon"],
	kunemon: ["Kune", "mon"],
	tentomon: ["Tento", "mon"],
	biyomon: ["Biyo", "mon"],
	patamon: ["Pata", "mon"],
	monochromon: ["Monochro", "mon"],
	birdramon: ["Birdra", "mon"],
	drimogemon: ["Drimoge", "mon"],
	garurumon: ["Garuru", "mon"],
	unimon: ["Uni", "mon"],
	leomon: ["Leo", "mon"],
	ogremon: ["Ogre", "mon"],
	ikkakumon: ["Ikkaku", "mon"],
	mojyamon: ["Mojya", "mon"],
	frigimon: ["Frigi", "mon"],
	kuwagamon: ["Kuwaga", "mon"],
	kabuterimon: ["Kabuteri", "mon"],
	flymon: ["Fly", "mon"],
	vegiemon: ["Vegie", "mon"],
	redvegiemon: ["RedVegie", "mon"],
	coelamon: ["Coela", "mon"],
	airdramon: ["Airdra", "mon"],
	angemon: ["Ange", "mon"],
	weregarurumon: ["WereGaruru", "mon"],
	megakabuterimon: ["MegaKabuteri", "mon"],
	garudamon: ["Garuda", "mon"],
	zudomon: ["Zudo", "mon"],
	megaseadramon: ["MegaSeadra", "mon"],
	okuwamon: ["Okuwa", "mon"],
	piximon: ["Pixi", "mon"],
	lillymon: ["Lilly", "mon"],
	whamon: ["Wha", "mon"],
	monzaemon: ["Monzae", "mon"],
	magnaangemon: ["MagnaAnge", "mon"],
	saberleomon: ["SaberLeo", "mon"],
	metalgarurumon: ["MetalGaruru", "mon"],
	machinedramon: ["Machinedra", "mon"],
	omnimon: ["Omni", "mon"],
	pagumon: ["Pagu", "mon"],
	gazimon: ["Gazi", "mon"],
	etemon: ["Ete", "mon"],
	metaletemon: ["MetalEte", "mon"],
	demidevimon: ["Demidevi", "mon"],
	devimon: ["Devi", "mon"],
	bakemon: ["Bake", "mon"],
	keramon: ["Kera", "mon"],
	infermon: ["Infer", "mon"],
	diaboromon: ["Diaboro", "mon"],
	wizardmon: ["Wizard", "mon"],
};

export function getFusionName(headId: string, bodyId: string) {
	if (!(headId in SplitNames) || !(bodyId in SplitNames)) return '';
	const headName = SplitNames[headId][0];
	let bodyName = SplitNames[bodyId][1];

	if (headName.endsWith('-') || headName.endsWith(' ')) {
		bodyName = bodyName.replace(' ', '').replace('-', '');
		bodyName = bodyName[0].toUpperCase() + bodyName.slice(1);
	}
	if (headName.endsWith(bodyName.charAt(0))) bodyName = bodyName.slice(1);

	return headName + bodyName;
}
